import type React from "react";
import * as S from "../styles";

type StepCardProps = {
  number: number;
  title: string;
  subtitle: string;
  imageSrc: string;
};

export const StepCard: React.FC<StepCardProps> = ({
  number,
  title,
  subtitle,
  imageSrc,
}) => {
  return (
    <S.Card>
      <S.NumberCircle>{number}</S.NumberCircle>
      <S.Title>{title}</S.Title>
      <S.Subtitle>{subtitle}</S.Subtitle>
      <S.ImageContainer>
        <S.Image src={imageSrc} alt={title} />
      </S.ImageContainer>
    </S.Card>
  );
};
